function getCategoryRoute(pageModel, productType = '') {
    var _models;
    const { productRoutes ={}  } = (_models = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page.models) !== null && _models !== void 0 ? _models : {};
    const key1 = Object.keys(productRoutes).find((key)=>key === productType && productRoutes
    );
    return key1 && productRoutes[key1];
}

export { getCategoryRoute };
//# sourceMappingURL=get-category-route.js.map
